module.exports = __webpack_public_path__ + "img/logo.b566a94b.png";